/*
 * sq-carousel.js — SQUADRIG Voltage product rail (§5.6) arrow controls.
 * Scroll-snap track, arrows scroll by exactly one card width + gap (read
 * from the DOM), debounced resize recompute, passive scroll listener,
 * RTL-aware direction, disabled state updated at both ends.
 */
(function () {
  'use strict';

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function initRail(rail) {
    var track = rail.querySelector('[data-sq-rail-track]');
    var prevBtn = rail.querySelector('[data-sq-rail-prev]');
    var nextBtn = rail.querySelector('[data-sq-rail-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function isRTL() {
      return getComputedStyle(track).direction === 'rtl';
    }

    function step() {
      var card = track.children[0];
      if (!card) return track.clientWidth;
      var cardWidth = card.getBoundingClientRect().width;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
      return cardWidth + gap;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    // Modern browsers report a negative scrollLeft range in RTL
    // (0 at the logical start, down to -maxScroll at the logical end).
    // Math.abs() normalizes both conventions to a 0..maxScroll position.
    function pos() {
      return Math.abs(track.scrollLeft);
    }

    function updateDisabled() {
      if (animating) return;
      var p = pos();
      var max = maxScroll();
      var atStart = p <= 1;
      var atEnd = p >= max - 1;

      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    // Overlapping smooth-scroll calls fight with scroll-snap and can swallow
    // a rapid second click (confirmed by testing) — lock the arrows for the
    // duration of one scroll animation instead of letting calls stack.
    var animating = false;
    function lockDuringScroll() {
      animating = true;
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      var done = function () {
        animating = false;
        track.removeEventListener('scrollend', done);
        updateDisabled();
      };
      if ('onscrollend' in window) {
        track.addEventListener('scrollend', done);
      } else {
        setTimeout(done, 450);
      }
    }

    function scrollByStep(dir) {
      if (animating) return;
      // dir: 1 = logical "next" (toward the end), -1 = logical "prev".
      var amount = step() * dir;
      if (isRTL()) amount *= -1;
      track.scrollBy({ left: amount, behavior: 'smooth' });
      lockDuringScroll();
    }

    prevBtn.addEventListener('click', function () { scrollByStep(-1); });
    nextBtn.addEventListener('click', function () { scrollByStep(1); });

    track.addEventListener('scroll', updateDisabled, { passive: true });
    window.addEventListener('resize', debounce(updateDisabled, 150));

    updateDisabled();
  }

  function init() {
    var rails = document.querySelectorAll('[data-sq-rail]');
    rails.forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
